/**
 * Removes all whitespace characters from a string
 * @param str - The input string
 * @returns The string without any whitespace
 * @example
 * clearSpaces("123 456 789") // "123456789"
 */
export function clearSpaces(str: string): string {
    return str.replace(/\s/g, "");
}
